export const summary = [
  {
    key: 1,
    label: "Recently viewed",
    dataKey: "login_user_recently_viewed_profile_count",
  },
  {
    key: 2,
    label: "Favorited by you",
    dataKey: "login_user_favourite_profile_count",
  },
  {
    key: 3,
    label: "You're interested in",
    dataKey: "login_user_interested_profile_count",
  },
  {
    key: 4,
    label: "Visited by you",
    dataKey: "login_user_visited_profile_count",
  },
  {
    key: 5,
    label: "Profiles I Visited",
    dataKey: "visited_profile_count",
  },
  {
    key: 6,
    label: "Favorited by me",
    dataKey: "favourite_profile_count",
  },
  {
    key: 7,
    label: "Interested in",
    dataKey: "interested_profile_count",
  },
  {
    key: 8,
    label: "Ignored profiles",
    dataKey: "ignored_profile_count",
  },
];
